var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.temPendentes
    ? _c(
        "span",
        {
          staticClass: "az-text-secondary az-size-14",
          attrs: { "data-test": "badge-vazio" }
        },
        [
          _vm._v(
            " " +
              _vm._s(_vm.indefinido ? _vm.texts.indefinido : _vm.texts.vazio) +
              " "
          )
        ]
      )
    : _c(
        "v-tooltip",
        {
          attrs: { bottom: "" },
          scopedSlots: _vm._u([
            {
              key: "activator",
              fn: function(ref) {
                var on = ref.on
                var attrs = ref.attrs
                return [
                  _c(
                    "v-chip",
                    _vm._g(
                      _vm._b(
                        {
                          staticClass:
                            "ia-suggestions-pending-badge az-chip-inline-badge",
                          attrs: {
                            small: "",
                            "aria-label": _vm.rotuloAria,
                            "data-test": "badge-alerta"
                          },
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.onRevisar($event)
                            }
                          }
                        },
                        "v-chip",
                        attrs,
                        false
                      ),
                      on
                    ),
                    [
                      _c("icon-svg", {
                        staticClass: "mr-1",
                        attrs: {
                          name: "warning",
                          size: "10",
                          color: "var(--warning-new)"
                        }
                      }),
                      _c(
                        "b",
                        { staticClass: "ia-suggestions-pending-badge__count" },
                        [_vm._v(_vm._s(_vm.pendentes))]
                      )
                    ],
                    1
                  )
                ]
              }
            }
          ])
        },
        [
          _c("span", { attrs: { "data-test": "badge-tooltip" } }, [
            _vm._v(" " + _vm._s(_vm.tituloTooltip)),
            _c("br"),
            _c("b", [_vm._v(_vm._s(_vm.texts.cliqueParaRevisar))])
          ])
        ]
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }